module.exports = __webpack_public_path__ + "static/Vedalken_female_Azorius-814fe6d7d2ee86f66db0bef79dabaac6.jpg";